import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { ChevronRightIcon, CornerRightFilledIcon } from '@gwc/icons';
import { Box } from '../box';
import { useSlot } from './hooks';
import { useColor } from '../../hooks/useColor';
import { Switch as GWCSwitch } from '../switch';
import styles from './styles.module.css';
export const Trail = memo(forwardRef(function Trail({ children, size, color, ...props }, ref) {
    const { sizeClass, context, elRef } = useSlot({ size, ref });
    return (React.createElement(Box, { ref: elRef, ...props, className: cn(sizeClass, styles.trail, props.className, {
            [styles.noTrailingPadding]: !!context.noTrailingPadding,
        }) }, children));
}));
const Nav = memo(forwardRef(function Nav({ color = 'main', className, ...rest }, ref) {
    const colorClass = useColor(color);
    return (React.createElement(Trail, { ...rest, ref: ref, className: cn(className, styles.nav, colorClass) },
        React.createElement(ChevronRightIcon, null)));
}));
const NavBold = memo(forwardRef(function NavBold({ color = 'main', className, ...rest }, ref) {
    const colorClass = useColor(color);
    return (React.createElement(Trail, { ...rest, ref: ref, pl: "xs", className: cn(className, styles.nav, colorClass) },
        React.createElement(CornerRightFilledIcon, null)));
}));
const Icon = memo(forwardRef(function Icon({ color = 'main', className, children, ...rest }, ref) {
    const colorClass = useColor(color);
    const { widthClass } = useSlot();
    return (React.createElement(Trail, { ...rest, ref: ref, alignContent: "center", justifyContent: "center", className: cn(className, styles.icon, widthClass, colorClass) }, children));
}));
const Switch = memo(forwardRef(function Switch({ className, on, onChange, disabled, error, size, ...rest }, ref) {
    return (React.createElement(Trail, { ...rest, ref: ref, alignContent: "center", className: cn(className, styles.switch) },
        React.createElement(GWCSwitch, { ...{ on, onChange, disabled, error, size } })));
}));
export const Trails = {
    Nav,
    NavBold,
    Icon,
    Switch,
};
